import { KeyboardReturn } from '@mui/icons-material';
import {
  Box,
  IconButton,
  Stack,
  Typography
} from '@mui/material';

import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { theme } from 'theme';



export type ActivityDetailHeaderSectionProps = {
  header: string;
  subHeader?: string;
  breadCrumbs?: ReactNode | ReactNode[];
  actions?: ReactNode | ReactNode [];
  children?: ReactNode | ReactNode [];
  removeBackButton?: boolean;
};

export const FC = (props: ActivityDetailHeaderSectionProps) => {
  const navigate = useNavigate();

  return (
    <Box
      borderBottom={`1px solid ${theme.palette.gray.light10}`}
    >
      <Box
        paddingY='.75rem'
        paddingX='1.5rem'
        display='flex'
        flexDirection='row'
        columnGap='1rem'
        alignItems='center'
      >
        {!props.removeBackButton && (
          <IconButton
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              border: `1px solid ${theme.palette.gray.light20}`,
              borderRadius: '.5rem',
              height: '2.5rem',
              width: '2.5rem'
            }}
            onClick={() => {
              navigate('..');
            }}
          >
            <KeyboardReturn />
          </IconButton>
        )}

        <Stack>
          <Typography
            variant='activityHeader'
          >
            {props.header ?? 'ACTIVITY NAME'}
          </Typography>
          <Typography
            variant='activitySubHeaderPrimary'
          >
            {props.subHeader}
          </Typography>
        </Stack>


        {/* Button group */}
        <Stack
          direction='row'
          flexWrap='wrap'
          justifyContent='flex-end'
          columnGap='.75rem'
          flex='3 1 0'
        >
          {props.actions}
        </Stack>
        {props.children}
      </Box>
    </Box>
  );
};
